import HelperIcon from "@wg/wows-react-uikit/HelperIcon";
import * as React from "react";
import { translate } from "react-i18next";
import { getAssignableRoles } from "roles";
import { RoleSelect } from "UIKit";
import MembersOperationDialog from "./MembersOperationDialog";
import styles from "./MembersOperationDialog.scss";

export interface ChangeRoleOperationDialogProps {
  currentAccountRoleName: string,
  members: Array<any>,
  memberToChangeId: number,
  selectedIds: Array<any>,
  selectedRole: string,

  onChangeClick: () => void,
  onCloseClick: () => void,
  onRoleSelect: () => void,
  t: (str: string) => string
}

export interface ChangeRoleOperationDialogState {
  selectedMembers: Array<any>,
  rolesToChange: Array<any>
  neverSelected: boolean,
}

class ChangeRoleOperationDialog extends React.Component<ChangeRoleOperationDialogProps, ChangeRoleOperationDialogState> {

  state = {
    selectedMembers: this.getSelectedMembers(),
    rolesToChange: getAssignableRoles(this.props.currentAccountRoleName),
    neverSelected: true
  }

  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    if (this.props.memberToChangeId !== nextProps.memberToChangeId || this.props.selectedIds !== nextProps.selectedIds || this.props.members !== nextProps.members) this.setState({
      selectedMembers: this.getSelectedMembers(nextProps)
    });
    if (this.props.currentAccountRoleName !== nextProps.currentAccountRoleName) this.setState({
      rolesToChange: getAssignableRoles(nextProps.currentAccountRoleName)
    });
  }

  getSelectedMembers(props = this.props) {
    const selectedMembers = props.memberToChangeId ? [props.memberToChangeId] : props.selectedIds;
    return props.members.filter(m => selectedMembers.includes(m.id));
  }

  onRoleSelect = role => {
    this.props.onRoleSelect(role);
    this.setState({ neverSelected: false });
  };

  render() {
    const t = this.props.t;
    const rolesList = this.state.rolesToChange.filter(role => {
      if (this.state.selectedMembers.length === 1) {
        const memberRole = (this.state.selectedMembers && this.state.selectedMembers[0] && this.state.selectedMembers[0].roleName) ? this.state.selectedMembers[0].roleName : null;
        return role !== memberRole;
      } else {
        return true;
      }
    });

    const roleSelect = (
      <div>
        <RoleSelect roles={rolesList} selected={this.props.selectedRole} onChange={this.onRoleSelect} />
        <div className={styles.helperIcon}>
          <HelperIcon
            header={t('Должности и полномочия')}
          >
            <div>
              <p>
                <dt>{t('Командующий флотом')}</dt>
                <dd>{t('Возведение строений на базе клана, просмотр количества нефти, добытого игроками клана со скрытой статистикой, распределение ресурсов и начисление контейнеров в казне, изменение названия, тега, описания клана, изменение должностей участников клана ниже по должности, приглашение и принятие в клан, исключение из клана и роспуск клана.:описание прав командующего флотом в тултипе')}</dd>
              </p>
              <p>
                <dt>{t('Заместитель командующего')}</dt>
                <dd>{t('Полномочия как у командующего, исключая роспуск клана.:описание прав заместителя командующего в тултипе')}</dd>
              </p>
              <p>
                <dt>{t('Военком')}</dt>
                <dd>{t('Приглашение и принятие в клан.:описание прав военкома в тултипе')}</dd>
              </p>
              <p>
                <dt>{t('Кадровый офицер')}</dt>
                <dd>{t('Без полномочий.:описание прав кадрового офицера в тултипе')}</dd>
              </p>
              <p>
                <dt>{t('Офицер')}</dt>
                <dd>{t('Без полномочий.:описание прав офицера в тултипе')}</dd>
              </p>
              <p>
                <dt>{t('Курсант')}</dt>
                <dd>{t('Без полномочий.:описание прав курсанта в тултипе')}</dd>
              </p>
            </div>
          </HelperIcon>
        </div>
      </div>
    )

    return (
      <MembersOperationDialog
        buttonActionTitle={t('Изменить')}
        buttonCloseTitle={t('Закрыть')}
        controlElement={roleSelect}
        membersForOperate={this.state.selectedMembers}
        spinnerLabel={t('Изменяем должность')}
        textBeforeMembers={t('Изменить роль игрокам:')}
        textAfterMembers={t('Назначить на должность:')}
        title={t('Смена должности')}
        buttonActionDisabled={this.state.neverSelected}
        onActionClick={this.props.onChangeClick}
        onCloseClick={this.props.onCloseClick}
      />
    )
  }
}

export default translate()(ChangeRoleOperationDialog);